module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0055.jpg?v=e2afd0e0";